"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handsOffPayloadToFormDataHandler = handsOffPayloadToFormDataHandler;
function handsOffPayloadToFormDataHandler(data) {
    return {
        frequencyRemaining: data.form.frequencyRemaining,
        startingFromWeekOf: data.form.startingFromWeekOf,
        notes: data.form.careNotesForFollowUpClinician || "",
    };
}
